import {FilterDialogSectionId, SavedFiltersSectionConfig} from 'filters/features/FilterDialog/types';

import {openFilterDialog} from 'filters/features/FilterDialog/emitter';
import {useEditedFilterContext} from 'filters/features/FilterDialog/contexts/internal/EditedFilterProvider/EditedFilterProvider';
import {useFilterActionsContext} from 'filters/contexts/FilterActionsProvider/FilterActionsProvider';

import {SecondaryActionButton} from 'modules/decisionsNext/components/DecisionsDialog';

export const SavedFiltersSecondaryAction = ({savedId}: Omit<SavedFiltersSectionConfig, 'footer'>) => {
  const {setFilter} = useEditedFilterContext();
  const {useStoredFilters} = useFilterActionsContext();
  const {savedFilters: filters} = useStoredFilters();

  return (
    <SecondaryActionButton
      disabled={!savedId}
      onClick={() => {
        const filter = savedId?.startsWith('filter-preset')
          ? filters.presets?.find(filter => filter.id === savedId)?.filter
          : filters.saved?.find(filter => filter.id === savedId)?.filter;

        if (!filter) {
          throw new Error(`No filter found ${savedId}`);
        }

        setFilter(filter);
        openFilterDialog(FilterDialogSectionId.ActiveFilters);
      }}
      data-testid='filter-dialog-preview-button'
    >
      Preview
    </SecondaryActionButton>
  );
};
